import { getApi } from '../../components/Shared/shared';
const baseURL = getApi();

export const paymentMethodUrls = {
  paymentMethod: `${baseURL}/payment-methods`
};

export default paymentMethodUrls;
